export type Raqam = {
  value: string;
  toEnglish: () => number | string;
};

export type RaqamOptions = {
  comma?: boolean;
  dash?: boolean;
  isNumber?: boolean;
};

const raqams: Array<string> = [
  "۰",
  "۱",
  "۲",
  "۳",
  "۴",
  "۵",
  "۶",
  "۷",
  "۸",
  "۹",
];

const commaSeparatedNumber = (string: string) => {
  const regex = /(\d+)(\d{3})/;
  while (regex.test(string)) {
    string = string.replace(regex, "$1,$2");
  }
  return string;
};

export const toPersian = (value: number | string, options: RaqamOptions) => {
  let stringNumber = `${value}`;
  if (options.comma) {
    stringNumber = commaSeparatedNumber(stringNumber);
  }
  const result: string = stringNumber.replace(/\d/g, (match) => {
    return raqams[parseInt(match)] ? raqams[parseInt(match)] : match;
  });
  return result;
};
